<div class="modal-header" *ngIf="showAsDialog">
    <h4 class="modal-title">Part Search - {{ mode }}</h4>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="d-flex align-items-center flex-shrink-0 m-1">
        <dx-file-uploader
            #priceUpdateFileUploader
            class="d-inline-block"
            style="width: 320px"
            name="priceUpdateFile"
            selectButtonText="Select Pricing CSV"
            accept=".csv"
            uploadMode="useForm"
            [multiple]="false"
            [showFileList]="false"
            [elementAttr]="{ title: 'Bulk-update Retail Price from a CSV. Required columns: Id, Part Number, Retail Price.' }"
            (onValueChanged)="priceUpdateFileSelected($event)"
        ></dx-file-uploader>
        <small class="text-muted ms-2">Bulk update pricing: upload a CSV with Id, Part Number, Retail Price columns.</small>
    </div>
    <div class="{{ !showSideBar ? ' d-contents' : ' flex-fill d-flex' }}">
        <div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '600px' : '100%' }" *ngIf="parts">
            <dx-data-grid
                #partsGrid
                [dataSource]="parts"
                keyExpr="id"
                [columnAutoWidth]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onRowPrepared)="rowPrepare($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onContentReady)="onContentReady($event)"
                (onExporting)="onExporting($event)"
            >
                <dxi-column dataField="id" [allowEditing]="false" width="80"></dxi-column>

                <dxi-column dataField="category" width="100" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="partNumber" width="250" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="description" width="250" [allowEditing]="false"></dxi-column>
                <!-- <dxi-column dataField="mfgPartNumber" width="100" [allowEditing]="!readOnly" [visible]="!showMfgInfoMode"></dxi-column> -->
                <!-- <dxi-column dataField="mfgDescription" width="100" [allowEditing]="!readOnly" [visible]="!columnLimitMode && !partDetailMode"></dxi-column> -->
                <dxi-column
                    *ngIf="canSeeCost"
                    dataField="cost"
                    [editorOptions]="{ step: 0 }"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                ></dxi-column>
                <dxi-column *ngIf="canSeeCost" dataField="calculatedCost" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
                <dxi-column
                    dataField="_manualRetailPrice"
                    [format]="{ type: 'currency', precision: 2 }"
                    [editorOptions]="{ step: 0 }"
                    caption="Edit"
                    [allowEditing]="true"
                    width="65"
                ></dxi-column>
                <dxi-column dataField="tierPricingOverride" width="65"></dxi-column>
                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="retailPrice"
                    [editorOptions]="{ step: 0 }"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                ></dxi-column>
                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="price"
                    caption="Dealer Price"
                    [editorOptions]="{ step: 0 }"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                ></dxi-column>
                <dxi-column dataField="tier1" caption="Tier Price (Base)" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="tier3" caption="Tier Price (3)" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="tier4" caption="Tier Price (4)" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="tier5" caption="Tier Price (5)" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>

                <dxi-column dataField="changeLog" width="100"></dxi-column>
                <dxi-column width="100"></dxi-column>

                <dxo-selection [mode]="selectMode"></dxo-selection>
                <dxo-search-panel *ngIf="!showAsDialog" class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-editing [mode]="'batch'" [allowUpdating]="!showAsDialog && !readOnly"></dxo-editing>
                <dxo-state-storing [enabled]="true" type="localStorage" [storageKey]="'part-pricing-grid'"></dxo-state-storing>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="'/parts/' + cell.data.id">{{ cell.value || '(blank)' }}</a>
                </div>
                <div *dxTemplate="let cell of 'poTemplate'">
                    <a [routerLink]="[]" (click)="purchaseOrderDialog(cell.data.id)">{{ cell.value || '' }}</a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <ng-container>
                        <button
                            class="btn btn-success"
                            (click)="open(partsGrid.instance.getSelectedRowsData()[0].id)"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                        >
                            Open
                        </button>
                        <button class="btn btn-secondary ms-2" (click)="updatePricing()">Update Pricing</button>
                        <button class="btn btn-danger ms-2" (click)="clearManualEdits()">Clear Edits</button>
                        <!-- <button
                            class="btn btn-danger ms-2"
                            (click)="delete(partsGrid.instance.getSelectedRowsData())"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length === 0"
                            [hidden]="!auth.hasRole('Administrator') || readOnly"
                        >
                            Delete
                        </button> -->
                        <!-- <button class="btn btn-primary ms-4" (click)="duplicate()" [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1" [hidden]="readOnly">
                            Duplicate
                        </button> -->
                        <!-- <button
                            class="btn btn-primary ms-4"
                            (click)="lookup(partsGrid.instance.getSelectedRowsData()[0].id)"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly"
                        >
                            Lookup
                        </button> -->

                        <!-- <button class="btn btn-primary ms-2" (click)="partTypeBulkEdit()" [disabled]="partsGrid.instance.getSelectedRowsData().length === 0" [hidden]="readOnly">
                            Part Type(s)
                        </button>
                        <button class="btn btn-primary ms-2" (click)="partOptionBulkEdit()" [disabled]="partsGrid.instance.getSelectedRowsData().length === 0" [hidden]="readOnly">
                            Options
                        </button> -->
                        <!-- <button
                            class="btn btn-warning ms-4"
                            (click)="bulkEdit(partsGrid.instance.getSelectedRowsData())"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length === 0"
                            [hidden]="readOnly"
                        >
                            Bulk Edit
                        </button>
                        <button
                            class="btn btn-secondary ms-4"
                            (click)="addPartPurchase(partsGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly"
                        >
                            Inventory Adjustment
                        </button> -->
                        <!-- <button class="btn btn-sm btn-success ms-2" (click)="refreshCalcCosts()" [hidden]="readOnly">Refresh Calculated Costs</button> -->
                        <button class="btn btn-sm btn-success ms-4" (click)="save()" *ngIf="hasChanges() && !readOnly" [hidden]="readOnly">Save</button>
                        <button class="btn btn-sm btn-danger ms-2" (click)="cancelEdits()" *ngIf="hasChanges() && !readOnly" [hidden]="readOnly">Cancel</button>
                    </ng-container>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="parts" class="me-3"
                        ><strong
                            >{{ partsGrid.instance.totalCount() + ' items' }}
                            {{ partsGrid.instance.getSelectedRowsData().length > 0 ? partsGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong></span
                    >
                </div>
            </dx-data-grid>
        </div>

        <div *ngIf="!!showSideBar && !!selectedParts && selectedParts.length > 0" class="flex-fill" style="max-width: 450px" [hidden]="selectedParts.length === 0">
            <div class="ps-4 pe-4">
                <h4>Selected Parts</h4>
                <table [hidden]="!selectedParts || selectedParts.length === 0" class="table table-hover">
                    <thead>
                        <tr>
                            <th>Part #</th>
                            <th>Description</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [hidden]="selectedParts.length > 0">
                            <td colspan="9">No items</td>
                        </tr>
                        <tr [hidden]="selectedParts.length === 0" *ngFor="let info of selectedParts">
                            <td class="col-xs-2">{{ info.partNumber }}</td>
                            <td class="col-xs-2">{{ info.description }}</td>
                            <td class="col-xs-2"><i class="fa fa-close" (click)="removeFromSelected(info)"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [visible]="isToastVisible"> </dx-toast>
    </div>
    <div class="modal-footer" *ngIf="showAsDialog">
        <button type="button" (click)="select(false)" class="btn btn-success ms-3">Select</button>
        <button type="button" (click)="closeDialog()" class="btn btn-secondary ms-1">Save & Close</button>
        <button type="button" (click)="cancel()" class="btn btn-danger ms-1">Cancel</button>
    </div>
</div>
